module.exports = __webpack_public_path__ + "static/media/ic_lock.93edcc0b.svg";